<template>
  <div v-if="distributorData" class="child-view">
    <div class="account-iframe__wrapper">
      <iframe
        class="account-iframe__object"
        :src="src"
        type="text/javascript"
        sandbox="allow-scripts allow-same-origin allow-downloads"
      ></iframe>
    </div>

    <a
      class="btn__back account-iframe__backbtn"
      href="#"
      @cancel="viewHistorial = false"
      @click="$emit('cancel')"
    >
      <span class="glicon-back-large-arrow"></span>
      <a @click="$router.go(-1)">{{ $t('actions.back') }}</a>
    </a>
  </div>
  <div v-else class="main__void">
    <div class="main__void--icon">
      <span class="glicon-axis-arrow"></span>
    </div>
    <span class="main__void--title">{{ $t('nouns.noDistributor') }}</span>
    <span class="main__void--subtitle"></span>
  </div>
</template>

<script>
import config from '../../config.json';
import { mapState } from 'vuex';

export default {
  name: 'CreditsRecord',
  computed: {
    ...mapState({
      distributorData: (state) => state.distributors.distributorData
    }),
    src() {
      return `${config.accounts.lmsUrl}/credits/partners/${this.distributorData.id}?microfrontend=true`;
    }
  }
};
</script>

<style scoped>
.label-distributor {
  padding: 20px;
}
</style>
